import { VerificationDocumentsHelper } from "app/helpers/verificationDocumentsHelper";
import type { VerificationDocumentType } from "app/types/documentType";
import {
  DocumentCategory,
  verificationDocumentMaxFileSizeMb,
} from "app/utils/const";
import React from "react";
import { FormattedMessage, IntlShape } from "react-intl";
import DocumentCategorySelector from "../DocumentCategorySelector/DocumentCategorySelector";
import "./CategorySelection.scss";

type Props = {
  selectedDocumentCategory: (typeof DocumentCategory)[keyof typeof DocumentCategory];
  documentList: VerificationDocumentType[];
  handleCategorySelect: (
    category: (typeof DocumentCategory)[keyof typeof DocumentCategory]
  ) => void;
  getDocuments: () => void;
  intl: IntlShape;
};

const CategorySelection: React.FC<Props> = ({
  selectedDocumentCategory,
  documentList,
  handleCategorySelect,
  getDocuments,
  intl,
}) => (
  <div className="category-selection">
    <h2>
      <FormattedMessage
        id="account-verification-verify-identity"
        defaultMessage="Verify Your Identity"
      />
    </h2>
    <div className="account-verification__content__inner">
      <p className="account-verification__content__inner__text">
        <FormattedMessage
          id="account-verification-description"
          defaultMessage="In line with our betting regulations, we require two different types of documents to verify your account, one to verify your identity and one to verify where you live."
        />
      </p>
      <p className="account-verification__content__inner__text">
        <FormattedMessage
          id="account-verification-accepted-formats"
          defaultMessage="Accepted formats: JPG, PNG, PDF (for PDF, only the first page will be processed)"
        />
      </p>
      <p className="account-verification__content__inner__text">
        <FormattedMessage
          id="account-verification-max-file-size"
          values={{
            verificationDocumentMaxFileSizeMb,
          }}
        />
      </p>
      <p className="account-verification__content__inner__text">
        <FormattedMessage
          id="account-verification-recent-will-upload"
          defaultMessage="Your most recently uploaded documents will be selected for the verification process."
        />
      </p>

      <DocumentCategorySelector
        title={VerificationDocumentsHelper.getText("photoIdTitle", intl)}
        description={VerificationDocumentsHelper.getText(
          "photoIdDescription",
          intl
        )}
        onSelect={() => handleCategorySelect(DocumentCategory.IDENTITY)}
        buttonText={VerificationDocumentsHelper.getText(
          "photoIdButtonText",
          intl
        )}
        disabled={selectedDocumentCategory !== DocumentCategory.IDENTITY}
        documentList={
          documentList
            ? documentList.filter(
                doc => doc.documentType === DocumentCategory.IDENTITY
              )
            : []
        }
        updateDocumentList={getDocuments}
        category={DocumentCategory.IDENTITY}
        intl={intl}
      />

      <DocumentCategorySelector
        title={VerificationDocumentsHelper.getText("poaTitle", intl)}
        description={VerificationDocumentsHelper.getText(
          "poaDescription",
          intl
        )}
        onSelect={() => handleCategorySelect(DocumentCategory.PROOFOFADDRESS)}
        buttonText={VerificationDocumentsHelper.getText("poaButtonText", intl)}
        disabled={selectedDocumentCategory !== DocumentCategory.PROOFOFADDRESS}
        documentList={
          documentList
            ? documentList.filter(
                doc => doc.documentType === DocumentCategory.PROOFOFADDRESS
              )
            : []
        }
        updateDocumentList={getDocuments}
        category={DocumentCategory.PROOFOFADDRESS}
        intl={intl}
      />
    </div>
  </div>
);

export default CategorySelection;
